var React = require('react');

function RadioButtonChecked (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Checkout-Desktop--January","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","transform":"translate(-459 -2080)"},React.createElement("g",{"id":"Group-13","transform":"translate(430 2051)"},React.createElement("g",{"id":"Group-5","transform":"translate(30 28)"},React.createElement("g",{"id":"Group-18","transform":"translate(0 2)"},[React.createElement("circle",{"id":"Oval","stroke":"#513265","fill":"#FFF","cx":"14","cy":"14","r":"14","key":0}),React.createElement("circle",{"id":"Oval-Copy","fill":"#513265","cx":"14","cy":"14","r":"10","key":1})])))));
}

RadioButtonChecked.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = RadioButtonChecked;

RadioButtonChecked.default = RadioButtonChecked;
